export const USERS_ACCOUNT_MAPPING_LOAD = 'USERS_ACCOUNT_MAPPING_LOAD'
export const usersAccountMappingLoad = userIds => ({
  type: USERS_ACCOUNT_MAPPING_LOAD,
  userIds
})

export const USERS_ACCOUNT_MAPPING_LOADED = 'USERS_ACCOUNT_MAPPING_LOADED'
export const usersAccountMappingLoaded = (userId, userDetails) => ({
  type: USERS_ACCOUNT_MAPPING_LOADED,
  userId: userId,
  userDetails
})

export const USERS_ACCOUNT_MAPPING_LOAD_FAILURE =
  'USERS_ACCOUNT_MAPPING_LOAD_FAILURE'
export const usersAccountMappingLoadFailure = (userId, error) => ({
  type: USERS_ACCOUNT_MAPPING_LOAD_FAILURE,
  userId,
  error
})
